/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Type_ContentInputs */

const en_manual_qc_type_content = /** @type {(inputs: Manual_Qc_Type_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content Issue`)
};

const fr_manual_qc_type_content = /** @type {(inputs: Manual_Qc_Type_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probleme de contenu`)
};

const de_manual_qc_type_content = /** @type {(inputs: Manual_Qc_Type_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhaltsproblem`)
};

const it_manual_qc_type_content = /** @type {(inputs: Manual_Qc_Type_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema di contenuto`)
};

const ru_manual_qc_type_content = /** @type {(inputs: Manual_Qc_Type_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вопрос содержания`)
};

const es_manual_qc_type_content = /** @type {(inputs: Manual_Qc_Type_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema de contenido`)
};

const zh_cn2_manual_qc_type_content = /** @type {(inputs: Manual_Qc_Type_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容问题`)
};

const ja_manual_qc_type_content = /** @type {(inputs: Manual_Qc_Type_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンテンツの問題`)
};

const hi_manual_qc_type_content = /** @type {(inputs: Manual_Qc_Type_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विषयवस्तु संबंधी समस्या`)
};

const pt_pt2_manual_qc_type_content = /** @type {(inputs: Manual_Qc_Type_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema de conteúdo`)
};

/**
* | output |
* | --- |
* | "Content Issue" |
*
* @param {Manual_Qc_Type_ContentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_type_content = /** @type {((inputs?: Manual_Qc_Type_ContentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Type_ContentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_type_content(inputs)
	if (locale === "de") return de_manual_qc_type_content(inputs)
	if (locale === "it") return it_manual_qc_type_content(inputs)
	if (locale === "ru") return ru_manual_qc_type_content(inputs)
	if (locale === "es") return es_manual_qc_type_content(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_type_content(inputs)
	if (locale === "ja") return ja_manual_qc_type_content(inputs)
	if (locale === "hi") return hi_manual_qc_type_content(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_type_content(inputs)
	return en_manual_qc_type_content(inputs)
});